export type HotelsParamName = "country_state_cityName" | "hotelId_hotelName" | "tab";
export const hotelsParamNames: SameRecord<HotelsParamName> = {
  country_state_cityName: "country_state_cityName",
  hotelId_hotelName: "hotelId_hotelName",
  tab: "tab",
};

export const HOTELS_PAGE_PATH = `/hotels/:${hotelsParamNames.country_state_cityName}/:${hotelsParamNames.hotelId_hotelName}/:${hotelsParamNames.tab}?`;
